module.exports = __webpack_public_path__ + "img/expressjs.51eb1579.png";